import React, { Component } from 'react'
import ReactDOM from 'react-dom'

/**
 *
 *
 * @param WrappedComponent      - inject component
 * @param showComponentState    - state for component show
 * @param toggleFunction        - function for show/hide component called after click outside
 * @param getFromState            - get showComponentState and toggleFunction from state otherwise props
 * @returns {{}}
 */
export default function wrapperClickOutside(WrappedComponent, showComponentState = null, toggleFunction = null, getFromState = true) {
    return class extends Component {

        componentDidMount = () => {
            document.addEventListener('mousedown', this.handleClickOutside)
        }

        componentWillUnmount = () => {
            document.removeEventListener('mousedown', this.handleClickOutside)
        }

        /**
         * Toggle if clicked on outside of element
         */
        handleClickOutside = event => {
            const ref = this.refs[WrappedComponent.name]

            if (!ref) {
                return null
            }

            const area = ReactDOM.findDOMNode(ref)
            const show = showComponentState === null ? ref?.state?.showSearch : (getFromState ? ref?.state?.[showComponentState] : ref?.props?.[showComponentState])

            if (ref && show && !area.contains(event.target)) {
                toggleFunction === null ? ref.toggleSearch() : (getFromState ? ref[toggleFunction](event) : ref.props[toggleFunction](event))
            }
        }

        render() {
            return (
                <WrappedComponent
                    ref={WrappedComponent.name}
                    {...this.props}
                />
            )
        }
    }
}
